import { logger } from '../../../../utils/common/logger'
import { IdentityEvent } from '../../../common/events/identity'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class VerificationEmailForm {
    private static DOM = {
        form: 'sendVerificationEmailForm'
    }
    private static formSelector = `[data-id-form=${VerificationEmailForm.DOM.form}]`
    private submissionEventName = 'send-verification-email'
    private successURL = '/verify-email-success'

    /**
     * Listens for the form validated event in the Send Verification Email form
     */
    public init() {
        logger('debug', 'Initializing Send Verification Email form')
        const form = this.getFormElement()

        if (form) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === VerificationEmailForm.DOM.form) {
                    await this.submitForm(form)
                }
            })
        }
        logger('debug', 'Send Verification Email Form initialized')
    }

    /**
     * Calls Send Verification Email LR API endpoint
     */
    public async submitForm(form: HTMLFormElement) {
        const formData = new FormData(form)
        // The dataObj creation below might be simplified with the Object.fromEntries but our current
        // ts config doesn't recognize it.
        // const dataObj: any = Object.fromEntries(data)
        const dataObj: any = {}
        formData.forEach((value, key) => dataObj[key] = value)

        try {
            await IdentityFormAPI.sendVerificationEmail(dataObj)
            return this.onSuccess()
        } catch (error) {
            const errors = IdentityFormUtils.structureErrors(error)
            return this.onError(errors)
        }
    }

    /**
     * Success callback function
     */
    protected onSuccess() {
        LoginService.sendFormSubmissionEvent(this.submissionEventName)
        // redirect to success page
        location.assign(this.successURL)
    }

    /**
     * Error callback function
     * @param errors any
     *
     */
    protected onError(errors: any) {
        LoginService.sendSubmissionErrorAnalytics(errors, this.submissionEventName)
        IdentityFormUtils.clearErrors()
        IdentityFormUtils.showErrors(VerificationEmailForm.formSelector, errors)
        logger('error', errors)
    }

    /**
     * Get HTMLFormElement representation of the Email Verification form
     */
    private getFormElement(): HTMLFormElement | undefined {
        return document.querySelector(VerificationEmailForm.formSelector)
    }
}
